export enum ESistema {
    Vesta = 1,
    PortalRelacionamento = 3
}